import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["itemsContainer", "itemTemplate", "itemRow", "quantity", "unitPrice", "subtotal", "totalQuantity", "grandTotal", "productSelect", "description", "destroyField"]

  connect() {
    this.calculateTotals()
  }

  addItem(event) {
    event.preventDefault()
    const template = this.itemTemplateTarget.innerHTML
    const newId = new Date().getTime()
    const newRow = template.replace(/NEW_RECORD/g, newId)
    this.itemsContainerTarget.insertAdjacentHTML("beforeend", newRow)
    this.calculateTotals()
  }

  removeItem(event) {
    event.preventDefault()
    const row = event.target.closest("tr")
    const destroyField = row.querySelector("[data-document-form-target='destroyField']")

    if (destroyField && destroyField.name.includes("[id]") === false) {
      // New record, just remove the row
      row.remove()
    } else {
      // Existing record, mark for destruction
      destroyField.value = "1"
      row.style.display = "none"
    }

    this.calculateTotals()
  }

  productSelected(event) {
    const select = event.target
    const row = select.closest("tr")
    const descriptionField = row.querySelector("[data-document-form-target='description']")
    const unitPriceField = row.querySelector("[data-document-form-target='unitPrice']")

    if (select.value) {
      const selectedOption = select.options[select.selectedIndex]
      const productName = selectedOption.text

      // Precio y nombre de la variante elegida
      fetch(`/api/variants/${select.value}.json`)
        .then(response => response.json())
        .then(variant => {
          if (descriptionField && !descriptionField.value) {
            descriptionField.value = variant.name
          }
          if (unitPriceField && !unitPriceField.value) {
            unitPriceField.value = variant.price
            this.calculateSubtotal({ target: unitPriceField })
          }
        })
        .catch(() => {
          // Si la API falla, al menos deja el nombre
          if (descriptionField && !descriptionField.value) {
            descriptionField.value = selectedOption.text
          }
        })
    }
  }

  calculateSubtotal(event) {
    const row = event.target.closest("tr")
    const quantity = parseFloat(row.querySelector("[data-document-form-target='quantity']").value) || 0
    const unitPrice = parseFloat(row.querySelector("[data-document-form-target='unitPrice']").value) || 0
    const subtotalEl = row.querySelector("[data-document-form-target='subtotal']")

    const subtotal = quantity * unitPrice
    subtotalEl.textContent = this.formatCurrency(subtotal)

    this.calculateTotals()
  }

  calculateTotals() {
    let totalQuantity = 0
    let grandTotal = 0

    this.itemRowTargets.forEach(row => {
      if (row.style.display !== "none") {
        const quantity = parseFloat(row.querySelector("[data-document-form-target='quantity']")?.value) || 0
        const unitPrice = parseFloat(row.querySelector("[data-document-form-target='unitPrice']")?.value) || 0
        const subtotal = quantity * unitPrice

        totalQuantity += quantity
        grandTotal += subtotal

        const subtotalEl = row.querySelector("[data-document-form-target='subtotal']")
        if (subtotalEl) {
          subtotalEl.textContent = this.formatCurrency(subtotal)
        }
      }
    })

    if (this.hasTotalQuantityTarget) {
      this.totalQuantityTarget.textContent = totalQuantity.toFixed(2)
    }
    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.formatCurrency(grandTotal)
    }
  }

  formatCurrency(amount) {
    return "$" + Math.round(amount).toLocaleString("es-CO")
  }
}
